(function($) {
    $( window ).on( 'load', function(){
    	'use strict';

        $( '.credsparkQuiz' ).attr( 'data-uuid', 'user-' + Date.now() );

        window.addEventListener( 'message', function(event) {
            var lyticsProperty;
            if ( event.origin === 'https://www.credspark.com' ) {
                if ( typeof event.data.embeddedRegistration !== 'undefined' ){
                    for ( var propertyName in event.data.embeddedRegistration.formData ){
                        // Reset lyticsProperty variable so it doesn't overwrite the previous one
                        lyticsProperty = '';
                        // if substring (3333) = data field -> add to lytics fields to send
                        if ( typeof $('.credsparkQuiz').data( propertyName.substring(25,29) ) !== 'undefined' ){
                            lyticsProperty = $('.credsparkQuiz').data( propertyName.substring(25,29) );
                        }
                        else if ( propertyName.indexOf( 'user' ) === 0 ){
                            lyticsProperty = propertyName.replace( 'user[', '' ).replace( ']', '' );
                        }

                        lytics.fields[lyticsProperty] = event.data.embeddedRegistration.formData[propertyName];
                    }
                    // Send credspark form data to lytics
                    lytics.sendData();
                }
            }
        });
    });
})(jQuery);